import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const flightTransactionReport = async (requestBody) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/api/Reports/Flight/AllTransactions`,
      requestBody,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Unexpected response status: ${response.status}`);
    }

  } catch (error) {
    console.error("Error fetching flight Transaction Report:", error);

    // Check if the error is an Axios error
    if (error.response) {
      // Server responded but returned an error code (4xx, 5xx)
      const { status, data } = error.response;
      console.error("Server error:", status, data);

      // You can throw a custom error for your UI
      throw new Error(
        data?.message ||
        `Server returned status ${status}. Please try again later.`
      );

    } else if (error.request) {
      // Request was made but no response (network/server down)
      console.error("No response received:", error.request);
      throw new Error("No response from server. Please check your connection.");

    } else {
      // Something else happened
      console.error("Unexpected error:", error.message);
      throw new Error("An unexpected error occurred. Please try again.");
    }
  }
};

export const flightUnflownTicketReport = async (requestBody) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/api/Reports/Flight/AllUnflownTicket`,
      requestBody,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Unexpected response status: ${response.status}`);
    }

  } catch (error) {
    console.error("Error fetching flight Transaction Report:", error);

    if (error.response) {
      const { status, data } = error.response;
      console.error("Server error:", status, data);

      throw new Error(
        data?.message ||
        `Server returned status ${status}. Please try again later.`
      );

    } else if (error.request) {
      console.error("No response received:", error.request);
      throw new Error("No response from server. Please check your connection.");

    } else {
      console.error("Unexpected error:", error.message);
      throw new Error("An unexpected error occurred. Please try again.");
    }
  }
};

export const flightSaleSummaryReport = async (requestBody) => {
  //console.log("requestBody:",requestBody)
  try {
    const response = await axios.post(
      `${API_BASE_URL}/api/Reports/Flight/SaleSummary`,
      requestBody,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Unexpected response status: ${response.status}`);
    }

  } catch (error) {
    console.error("Error fetching flight Transaction Report:", error);

    if (error.response) {
      const { status, data } = error.response;
      console.error("Server error:", status, data);

      throw new Error(
        data?.message ||
        `Server returned status ${status}. Please try again later.`
      );

    } else if (error.request) {
      console.error("No response received:", error.request);
      throw new Error("No response from server. Please check your connection.");

    } else {
      console.error("Unexpected error:", error.message);
      throw new Error("An unexpected error occurred. Please try again.");
    }
  }
};

export const CancelledBookingsReport = async (requestBody) => {
  //console.log("requestBody:",requestBody)
  try {
    const response = await axios.post(
      `${API_BASE_URL}/api/Reports/Flight/AllCancelledBookings`,
      requestBody,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Unexpected response status: ${response.status}`);
    }

  } catch (error) {
    console.error("Error fetching flight Transaction Report:", error);

    if (error.response) {
      const { status, data } = error.response;
      console.error("Server error:", status, data);

      throw new Error(
        data?.message ||
        `Server returned status ${status}. Please try again later.`
      );

    } else if (error.request) {
      console.error("No response received:", error.request);
      throw new Error("No response from server. Please check your connection.");

    } else {
      console.error("Unexpected error:", error.message);
      throw new Error("An unexpected error occurred. Please try again.");
    }
  }
};

//Insurance Reports
export const InsuranceTransactionReport = async (requestBody) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/api/Reports/Insurance/AllTransactions`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching Booking Summary:", error);
    throw error;
  }
};

//ForexTransaction
export const ForexTransaction = async (requestBody) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/api/Reports/Forex/AllTransactions`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching Booking Summary:", error);
    throw error;
  }
};

//CabTransaction
export const CabTransaction = async (requestBody) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/api/Reports/Cabs/AllTransactions`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching Booking Summary:", error);
    throw error;
  }
};

//VisaTransaction
export const VisaTransaction = async (requestBody) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/api/Reports/Visa/AllTransactions`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching Booking Summary:", error);
    throw error;
  }
};

//BusTransaction
export const BusTransaction = async (requestBody) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/api/Reports/Bus/AllTransactions`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching Booking Summary:", error);
    throw error;
  }
};



//TrainTransaction
export const TrainTransaction = async (requestBody) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/api/Reports/Rail/AllTransactions`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching Booking Summary:", error);
    throw error;
  }
};


export const GetAllReservationsCount = async (userName) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/api/Reports/Dashboard/AllTransactionsCount`,
      {
        params: { userName },
      }
    );
    return response.data.allTransactionsCount;
  } catch (error) {
    console.error("Error fetching Booking Summary:", error);
    throw error;
  }
};

export const GetTransactionDetails = async (params) => {
  //console.log(params.ProductType)
  //console.log("url", `${API_BASE_URL}/api/Reports/${params.ProductType}/TransactionDetails`)
  try {
    const response = await axios.get(
      `${API_BASE_URL}/api/Reports/${params.ProductType}/TransactionDetails`,
      {
       params: {
          Id: params.Id,
          ReferenceNo: params.ReferenceNo,
        },
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data.transactionDetails;
  } catch (error) {
    console.error("Error fetching Booking Summary:", error);
    throw error;
  }
};

export const lowFareFlightReport = async (requestBody) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/api/Reports/Flight/LowFareFlightReport`,
      requestBody,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Unexpected response status: ${response.status}`);
    }

  } catch (error) {
    console.error("Error fetching flight Transaction Report:", error);
    if (error.response) {
      const { status, data } = error.response;
      console.error("Server error:", status, data);
      throw new Error(
        data?.message ||
        `Server returned status ${status}. Please try again later.`
      );

    } else if (error.request) {
      console.error("No response received:", error.request);
      throw new Error("No response from server. Please check your connection.");

    } else {
      console.error("Unexpected error:", error.message);
      throw new Error("An unexpected error occurred. Please try again.");
    }
  }
};
